import { isFeatureEnabled } from '@luna/gatekeeper';
import { deepClean } from '@luna/utils';

export const getTransactionsFeaturesParams = (): Record<string, string> => {
    const continuousCardIdFiltering = isFeatureEnabled(
        ({ transactions }) => transactions.continuousCardIdFiltering,
    );

    const displayExecutionDate = isFeatureEnabled(
        ({ transactions }) => transactions.displayExecutionDate,
    );

    return deepClean({
        continuousCardIdFiltering: String(continuousCardIdFiltering),
        mainDate: displayExecutionDate ? 'transactionDateTime' : undefined,
    });
};
